var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10.5664C17 13.8801 14.3137 16.5664 11 16.5664C7.68629 16.5664 5 13.8801 5 10.5664C5 7.2527 7.68629 4.56641 11 4.56641C14.3137 4.56641 17 7.2527 17 10.5664ZM15.8775 16.908C14.5274 17.948 12.8359 18.5664 11 18.5664C6.58172 18.5664 3 14.9847 3 10.5664C3 6.14813 6.58172 2.56641 11 2.56641C15.4183 2.56641 19 6.14813 19 10.5664C19 12.4279 18.3642 14.1409 17.298 15.5001L21.8174 20.0195C22.2079 20.41 22.2079 21.0431 21.8174 21.4337C21.4269 21.8242 20.7937 21.8242 20.4032 21.4337L15.8775 16.908Z",
    fill: "white",
    fillOpacity: 0.95
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.0b3a1b91b64400a1255fa546e8e419d9.svg";
export { ForwardRef as ReactComponent };